module.exports = __webpack_public_path__ + "img/s4.82b691ca.png";